export default "__VITE_ASSET__4391e919__"